export const requestIsSuccessful = (status) => status >= 200 && status <= 300
export const requestHasNoContent = (status) => status === 204
